import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FileUploadAwareJsonWriterClass;
function FileUploadAwareJsonWriter() {
  if (FileUploadAwareJsonWriterClass === VOID) {
    class $ {
      constructor(wrappedWriter) {
        this.r47_1 = wrappedWriter;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.s47_1 = LinkedHashMap().bc();
      }
      t47() {
        return this.s47_1;
      }
      t40() {
        // Inline function 'kotlin.apply' call
        this.r47_1.t40();
        return this;
      }
      u40() {
        // Inline function 'kotlin.apply' call
        this.r47_1.u40();
        return this;
      }
      o40() {
        // Inline function 'kotlin.apply' call
        this.r47_1.o40();
        return this;
      }
      p40() {
        // Inline function 'kotlin.apply' call
        this.r47_1.p40();
        return this;
      }
      q47(name) {
        // Inline function 'kotlin.apply' call
        this.r47_1.q47(name);
        return this;
      }
      a41(value) {
        // Inline function 'kotlin.apply' call
        this.r47_1.a41(value);
        return this;
      }
      k41(value) {
        // Inline function 'kotlin.apply' call
        this.r47_1.k41(value);
        return this;
      }
      f41(value) {
        // Inline function 'kotlin.apply' call
        this.r47_1.f41(value);
        return this;
      }
      c41(value) {
        // Inline function 'kotlin.apply' call
        this.r47_1.c41(value);
        return this;
      }
      i41(value) {
        // Inline function 'kotlin.apply' call
        this.r47_1.i41(value);
        return this;
      }
      g4a(value) {
        // Inline function 'kotlin.apply' call
        this.r47_1.g4a(value);
        return this;
      }
      p41(value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.s47_1;
        // Inline function 'kotlin.collections.set' call
        var key = this.r47_1.v49();
        tmp0.x4(key, value);
        this.r47_1.t3z();
        return this;
      }
      t3z() {
        // Inline function 'kotlin.apply' call
        this.r47_1.t3z();
        return this;
      }
      v49() {
        return this.r47_1.v49();
      }
      l6() {
        this.r47_1.l6();
      }
    }
    initMetadataForClass($, 'FileUploadAwareJsonWriter');
    FileUploadAwareJsonWriterClass = $;
  }
  return FileUploadAwareJsonWriterClass;
}
//region block: exports
export {
  FileUploadAwareJsonWriter as FileUploadAwareJsonWriter1mx337tg0y9oj,
};
//endregion

//# sourceMappingURL=FileUploadAwareJsonWriter.mjs.map
